var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('h4',[_vm._v("Bilty")])]),_c('b-card-body',[_c('bilty-filters',{on:{"filtersUpdated":_vm.filtersChangeHandler}}),_c('bilty-list',{attrs:{"filters":_vm.filters}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }